import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'auth-layout',
    standalone: true,
    imports: [RouterModule],
    template: `<router-outlet />`
})
export class AuthLayout {}
